<template>
  <div class="footer basic-padding-left-right">
    <div class="main-info">
      <div class="footer-left">
<!--        <img v-lazy="`${$imgUrl}footer-logo.png`">-->
        <img src="@/static/images/logo2.png">
      </div>
      <div class="footer-center">
        <div class="footer-title">
          {{ $t('item.value', { value: $i18n.locale==='en' ? 'Official Media' :  '官网媒体' }) }}
          <div class="footer-title-line"></div>
        </div>
        <div class="qr-list">
          <div class="flex-center-column">
            <div style="width: 100px;height: 100px;margin-bottom: 15px;">
              <img v-lazy="`${$imgUrl}guanfwx.png`">
            </div>
            <div>官方微信</div>
          </div>
<!--          <div class="flex-center-column">-->
<!--            <div style="width: 100px;height: 100px;margin-bottom: 15px;">-->
<!--              <img v-lazy="`${$imgUrl}douyin.png`">-->
<!--            </div>-->
<!--            <div>抖音号</div>-->
<!--          </div>-->
          <div class="flex-center-column">
            <div style="width: 100px;height: 100px;margin-bottom: 15px;">
              <img v-lazy="`${$imgUrl}shiping2.jpg`">
            </div>
            <div>砼程视界（视频号）</div>
          </div>
        </div>
      </div>
      <div class="footer-right">
        <div class="footer-title">
          {{ $t('item.value', { value: $i18n.locale==='en' ? 'Contact Us' :  '联系我们' }) }}
          <div class="footer-title-line"></div>
        </div>
        <div class="contract-list">
          <div class="contract-list-item" v-for="(item,index) in contractList" :key="index">
            <div>{{ $t('item.value', { value: $i18n.locale==='en' ? item.engName:  item.name }) }}</div>
            <div>{{item.phoneNum}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="line"></div>
    <div class="footer-argument" >
      <img v-lazy="`${$imgUrl}footer-license.png`" style="width: 20px;height: 20px;margin-right: 10px">
      <div>© 2024 宁波砼程数智科技有限公司 </div>
      <div style="cursor: pointer;margin-left: 5px" @click="openLink"> 浙ICP备2023027274号-1</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Footer',
  methods: {
    openLink(){
      window.open('https://beian.miit.gov.cn/#/Integrated/index')
    }
  },
  data() {
    return{
      contractList:[
        {name:"业务咨询",engName:"Business Consulting", phoneNum:"18057400675"},
        {name:"合伙人咨询",engName:"Partner Consulting",phoneNum:"18057400675"},
        {name:"媒体合作",engName:"Media Cooperation",phoneNum:"18069056356"},
      ]
    }
  }
}
</script>
<style lang="less" scoped>
.footer {
  box-sizing: border-box;
  width: 100%;
  height: 345px;
  background: #F5F5F7;
  display: flex;
  flex-direction: column;

  .main-info {
    width: 100%;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding-top: 45px;
    .footer-left{
      display: flex;
      align-items: center;
      img{
        width: 280px;
        height: 75px;
      }
    }
    .footer-title {
      display: flex;
      flex-direction: column;
      font-weight: 500;
      font-size: 16px;
      color: rgba(0, 0, 0, 1);
      height: 55px;
      .footer-title-line {
        width: 20px;
        height: 3px;
        background: #020202;
        margin-top: 8px;
      }
    }

    .footer-center {
      display: flex;
      flex-direction: column;
      width: 425px;

      .qr-list {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
    .footer-right{
      display: flex;
      flex-direction: column;

      .contract-list{
        width: 225px;
        display: flex;
        flex-direction: column;
        font-weight: 400;
        font-size: 14px;
        color: rgba(0,0,0,0.65);
        .contract-list-item{
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 15px;
        }
      }
    }
  }

  .line {
    margin-top: 45px;
    width: 100%;
    border-bottom: 1px solid #E4E4EB;
  }
  .footer-argument{
    margin-top: 30px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 400;
    font-size: 12px;
    color: rgba(0,0,0,0.55);
  }
}
</style>